import { useEffect } from "react";
import './ContactPage.css';
import AegleDivider from "../components/AegleDivider";

const ContactPage: React.FC = () => {
    useEffect(() => {
        // Create script element
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
        script.async = true;

        // Append script to body
        document.body.appendChild(script);

        // Cleanup function to remove script when component unmounts
        return () => {
            document.body.removeChild(script);
        };
    }, []);
    
    // Contact Us Boxes
    return (
        <>
            <section className="contact-us-section">
                <h1>Contact Us</h1>
                <AegleDivider color="#368caa" />
                <p>Schedule a meeting with our team to discuss how we can support your needs and explore potential opportunities.</p>
            </section>
            <section className="meeting-section">
                <div className="meetings-iframe-container"
                    data-src="https://meetings.hubspot.com/carl-schwappach/aegle-website-connect-page?embed=true"
                ></div>

                <div className="contact-boxes-container">
                        {                 
                    
                    <div className="contact-box">
                        <svg width="75" height="75" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="#368caa" />
                        </svg>
                        <h3>MAIN OFFICE</h3>
                        <p>708 N 1st St, Ste 342<br />Minneapolis, MN 55401</p>
                    </div> }
                    <div className="contact-box">
                        <div className="contact-box-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="75" height="75" viewBox="0 0 24 24" fill="#368caa">
                                <path d="M22 7.535V17a3 3 0 0 1-2.824 2.995L19 20H5a3 3 0 0 1-2.995-2.824L2 17V7.535l9.445 6.297l.116.066a1 1 0 0 0 .878 0l.116-.066L22 7.535z" />
                                <path d="M19 4c1.08 0 2.027.57 2.555 1.427L12 11.797l-9.555-6.37a2.999 2.999 0 0 1 2.354-1.42L5 4h14z" />
                            </svg>
                        </div>
                        <h3>EMAIL</h3>
                        <p><a href="mailto:info@aeglecap.com">info@aeglecap.com</a></p>
                    </div>
                </div>
            </section>

        </>

    );
};

export default ContactPage;
